import React from "react";

export interface Shortage {
  productId: number;
  name: string;
  need: number;
  available: number;
  missing: number;
}

interface Props {
  shortages: Shortage[];
  onClose: () => void;
  onOpenWarehouse?: () => void;
}

export default function StockShortageModal({ shortages, onClose, onOpenWarehouse }: Props) {
  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()} role="alertdialog" aria-modal="true">
        <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
          <div style={icon}>📦</div>
          <div>
            <h2 style={{ margin: 0, fontSize: 19, color: "#f3f4f6" }}>Не хватает товара на складе</h2>
            <div style={{ fontSize: 13, color: "#9ca3af", marginTop: 4 }}>
              Сделку нельзя завершить, пока на складе нет нужного количества. Оформите приход или уменьшите количество в сделке.
            </div>
          </div>
        </div>

        <div style={{ marginTop: 16, border: "1px solid #1f2937", borderRadius: 10, overflow: "hidden" }}>
          <div style={{ ...row, background: "#0f1520", color: "#6b7280", fontSize: 11, textTransform: "uppercase", letterSpacing: 0.4 }}>
            <span style={{ flex: 1 }}>Товар</span>
            <span style={num}>Нужно</span>
            <span style={num}>Есть</span>
            <span style={{ ...num, width: 78 }}>Не хватает</span>
          </div>
          {shortages.map((s) => (
            <div key={s.productId} style={{ ...row, borderTop: "1px solid #1f2937" }}>
              <span style={{ flex: 1, fontSize: 14, color: "#e5e7eb" }}>{s.name}</span>
              <span style={num}>{s.need}</span>
              <span style={{ ...num, color: s.available > 0 ? "#f59e0b" : "#f87171" }}>{s.available}</span>
              <span style={{ ...num, width: 78, color: "#f87171", fontWeight: 700 }}>−{s.missing}</span>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 18 }}>
          {onOpenWarehouse && (
            <button style={{ ...btn, background: "#374151" }} onClick={onOpenWarehouse}>Открыть склад</button>
          )}
          <button style={{ ...btn, background: "#2563eb" }} onClick={onClose} autoFocus>Понятно</button>
        </div>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = { position: "fixed", inset: 0, zIndex: 20000, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", padding: 14 };
const modal: React.CSSProperties = { width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto", background: "#131926", border: "1px solid #7f1d1d", borderRadius: 14, padding: 22, boxShadow: "0 20px 60px rgba(0,0,0,0.6)" };
const icon: React.CSSProperties = { width: 44, height: 44, flexShrink: 0, borderRadius: 12, background: "rgba(239,68,68,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 };
const row: React.CSSProperties = { display: "flex", alignItems: "center", gap: 8, padding: "10px 12px" };
const num: React.CSSProperties = { width: 56, textAlign: "right", fontSize: 14, color: "#d1d5db", flexShrink: 0 };
const btn: React.CSSProperties = { color: "#fff", border: "none", borderRadius: 8, padding: "10px 18px", fontSize: 14, fontWeight: 600, cursor: "pointer" };
